import DangerButton from './DangerButton';

export default DangerButton;
